export interface UserDropdownActionType {
  type: UserDropdown;
  payload?: any;
}

export enum UserDropdown {
  GET_USER_DROPDOWN_LIST = "GET_USER_DROPDOWN_LIST",
  SET_USER_DROPDOWN_LIST = "SET_USER_DROPDOWN_LIST",
  SET_USER_DROPDOWN_LOADING = "SET_USER_DROPDOWN_LOADING",
}
